import React from 'react';
import { X, Plus, Minus, ShoppingBag } from 'lucide-react';

export default function CartDrawer({ open, onClose, items, setItems }) {
  const inc = (id) => setItems((arr) => arr.map((it) => it.id === id ? { ...it, qty: it.qty + 1 } : it));
  const dec = (id) => setItems((arr) => arr.flatMap((it) => it.id === id ? (it.qty > 1 ? [{ ...it, qty: it.qty - 1 }] : []) : [it]));
  const remove = (id) => setItems((arr) => arr.filter((it) => it.id !== id));
  const total = items.reduce((s, it) => s + it.price * it.qty, 0);

  return (
    <div className={`fixed inset-0 z-50 ${open ? '' : 'pointer-events-none'}`}>
      <div onClick={onClose} className={`absolute inset-0 bg-black/40 transition-opacity ${open ? 'opacity-100' : 'opacity-0'}`} />
      <aside className={`absolute right-0 top-0 bottom-0 w-full sm:w-[420px] bg-white dark:bg-neutral-950 shadow-2xl transition-transform duration-300 ${open ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="flex items-center justify-between p-5 border-b border-black/5 dark:border-white/5">
          <div className="flex items-center gap-2">
            <ShoppingBag size={16} />
            <div className="font-grotesk font-semibold tracking-tight">Your Cart</div>
          </div>
          <button onClick={onClose} aria-label="Close" className="h-8 w-8 inline-flex items-center justify-center rounded-full hover:bg-black/5 dark:hover:bg-white/10">
            <X size={16} />
          </button>
        </div>
        <div className="h-[calc(100%-180px)] overflow-y-auto p-5 space-y-4">
          {items.length === 0 && (
            <div className="text-center text-neutral-500 py-16">
              <ShoppingBag size={28} className="mx-auto opacity-40" />
              <p className="mt-3 text-sm">Your cart is empty. Time to stack up.</p>
            </div>
          )}
          {items.map((it) => (
            <div key={it.id} className="flex gap-3">
              <div className="w-20 h-20 rounded-xl overflow-hidden bg-neutral-100 dark:bg-neutral-900 shrink-0">
                <img src={it.image} alt={it.name} className="w-full h-full object-cover" />
              </div>
              <div className="flex-1">
                <div className="font-grotesk font-medium text-[15px] leading-tight">{it.name}</div>
                <div className="text-[12px] text-neutral-500">{it.subtitle}</div>
                <div className="flex items-center justify-between mt-2">
                  <div className="inline-flex items-center rounded-full border border-black/10 dark:border-white/10">
                    <button onClick={() => dec(it.id)} className="h-7 w-7 inline-flex items-center justify-center"><Minus size={12} /></button>
                    <span className="px-2 text-sm w-6 text-center">{it.qty}</span>
                    <button onClick={() => inc(it.id)} className="h-7 w-7 inline-flex items-center justify-center"><Plus size={12} /></button>
                  </div>
                  <div className="text-sm font-semibold">₹{(it.price * it.qty).toLocaleString()}</div>
                </div>
              </div>
              <button onClick={() => remove(it.id)} className="h-7 w-7 rounded-full hover:bg-black/5 dark:hover:bg-white/10 inline-flex items-center justify-center self-start">
                <X size={12} />
              </button>
            </div>
          ))}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-5 border-t border-black/5 dark:border-white/5 bg-white dark:bg-neutral-950">
          <div className="flex items-center justify-between mb-3">
            <span className="text-sm text-neutral-500">Subtotal</span>
            <span className="font-grotesk font-semibold text-lg">₹{total.toLocaleString()}</span>
          </div>
          <button disabled={items.length === 0} className="w-full py-3 rounded-full bg-black text-white dark:bg-white dark:text-black font-medium text-sm hover:opacity-90 transition disabled:opacity-40">Checkout</button>
        </div>
      </aside>
    </div>
  );
}
